// extracted by mini-css-extract-plugin
module.exports = {"authorAvatar":"ArticleFooter_authorAvatar__Wiz_2","tagsContainer":"ArticleFooter_tagsContainer__hV1a_"};